<template>
    <div class="flex justify-between">
        <QrHeader :text="trans('header.create-menu-page')" trans="header.create-menu-page"/>
        <QrButton
            :href="`/code/${qrCode.uid}/homepage?preview=1`"
            :text="trans('button.view-homepage')" trans="button.view-homepage"
            icon-right="arrow-up-right-from-square"
            target="_blank"
            small
        />
    </div>

    <div class="mt-4 space-y-4">
        <HomepageBuilder/>

        <div class="flex justify-between">
            <QrButton
                to="/create/type"
                :text="trans('button.back')"
                trans="button.back"
                secondary
                icon="arrow-left"
            />

            <QrButton
                @click="create"
                :text="trans('button.continue')"
                trans="button.continue"
                icon-right="arrow-right"
                :loading="loading"
                :recently-succeeded="recentlySucceeded"
            />
        </div>
    </div>
</template>

<script setup>
import { trans } from "@/libs/helper.js";
import QrHeader from "@/components/application-ui/content/QrHeader.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import { useQrCodesStore } from "@/store/qrCodes.js";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import HomePageLink from "@/components/qr-code/homepage/HomePageLink.vue";
import HomePageGallery from "@/components/qr-code/homepage/HomePageGallery.vue";
import HomePageVideo from "@/components/qr-code/homepage/HomePageVideo.vue";
import HomePageDocument from "@/components/qr-code/homepage/HomePageDocument.vue";
import QrCard from "@/components/application-ui/panels/QrCard.vue";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import QrParagraph from "@/components/application-ui/content/QrParagraph.vue";
import DeleteHomePageContent from "@/components/qr-code/homepage/DeleteHomePageContent.vue";
import HomepageBuilder from "@/components/qr-code/homepage/HomepageBuilder.vue";
import {useStatesStore} from "@/store/states.js";

const statesStore = useStatesStore();
const { loading, recentlySucceeded } = storeToRefs(statesStore);

const router = useRouter();
const qrCodeStore = useQrCodesStore();
const { newQrCode, qrCode } = storeToRefs(qrCodeStore);

const create = async () => {
    await qrCodeStore.update()

    await router.push(`/create/design/${qrCode.value.id}`)
};

onMounted(() => {
    newQrCode.value.step = 2.5
});

</script>
